import { render } from "./transactions.vue?vue&type=template&id=12bd00d6"
import script from "./transactions.vue?vue&type=script&lang=js"
export * from "./transactions.vue?vue&type=script&lang=js"

import "./transactions.vue?vue&type=style&index=0&id=12bd00d6&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__